// src/components/UserDropdown.jsx
import React from 'react';
import { Dropdown, Image } from 'react-bootstrap'; // Asegúrate de importar Image
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserCircle, // Para el fallback si no hay avatar
    faSignOutAlt,
    faTachometerAlt, // Cambiado de faChartBar para coincidir con MainPage
    faCog // Para el perfil, si prefieres sobre faUser
} from '@fortawesome/free-solid-svg-icons';

// Componente CustomToggle para un mejor control del diseño y accesibilidad
const CustomToggle = React.forwardRef(({ children, onClick, userName, avatarUrl }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        className="nav-link dropdown-toggle d-flex align-items-center" // Clases Bootstrap para estilo de Navbar
        style={{ textDecoration: 'none', color: 'inherit' }} // Estilos para que se vea como un link normal
    >
        {avatarUrl ? (
            <Image
                src={avatarUrl}
                alt={userName || 'User Avatar'}
                roundedCircle
                style={{ width: '32px', height: '32px', marginRight: '10px', objectFit: 'cover' }}
            />
        ) : (
            <FontAwesomeIcon
                icon={faUserCircle}
                size="lg" // o 'xl' si quieres más grande
                className="me-2" // margen a la derecha
                style={{ fontSize: '28px', color: '#6c757d' }} // Ajusta tamaño y color
            />
        )}
        <span className="d-none d-sm-inline">{userName || 'User'}</span> {/* Oculta el nombre en pantallas muy pequeñas si es necesario */}
        {children} {/* Esto es para el caret del dropdown */}
    </a>
));


const UserDropdown = ({ user, userName, avatarUrl, onLogout, onOpenProfile, onOpenDashboard }) => {
    // Si no hay usuario, no mostrar el dropdown (o podrías mostrar un botón de Login)
    if (!user) {
        return null;
    }

    console.log("UserDropdown rendered with user:", user);

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                as={CustomToggle}
                id="user-dropdown-custom-toggle"
                // Pasa las props necesarias al CustomToggle
                userName={userName}
                avatarUrl={avatarUrl}
            >
                {/* El caret del dropdown se renderizará automáticamente por Bootstrap */}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ minWidth: '220px', marginTop: '0.5rem' }}> {/* Añade un poco de margen superior */}
                <Dropdown.Header>
                    <div className="d-flex align-items-center mb-1">
                        {avatarUrl ? (
                            <Image src={avatarUrl} roundedCircle style={{ width: '40px', height: '40px', marginRight: '10px', objectFit: 'cover' }} />
                        ) : (
                            <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: '40px', color: '#6c757d', marginRight: '10px' }} />
                        )}
                        <div>
                            <strong>{userName}</strong><br />
                            <small className="text-muted">{user.email}</small>
                        </div>
                    </div>
                </Dropdown.Header>
                <Dropdown.Divider />
                <Dropdown.Item onClick={onOpenProfile}>
                    <FontAwesomeIcon icon={faCog} className="me-2 fa-fw" /> My Profile
                </Dropdown.Item>
                <Dropdown.Item onClick={onOpenDashboard}>
                    <FontAwesomeIcon icon={faTachometerAlt} className="me-2 fa-fw" /> Dashboard
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={onLogout} className="text-danger">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2 fa-fw" /> Logout
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UserDropdown;